import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

const MSG = {
    GROUP: "Anda akan mengaktifkan H&T Group Reporting. Data laporan lama tidak akan dihapus atau diubah. Lanjutkan?",
    LEGACY: "Anda akan kembali ke Reporting lama (LEGACY). Data H&T Group Reporting tidak akan dihapus atau diubah dan akan tampil lagi saat GROUP diaktifkan kembali. Lanjutkan?",
};
const LABEL = { LEGACY: "LEGACY — Reporting lama (laporan harian per admin)", GROUP: "GROUP — H&T Group Reporting" };

export default function ModeSwitch() {
    const [mode, setMode] = useState(null);
    const [target, setTarget] = useState(null);
    useEffect(() => { api.get("/reporting/mode").then((r) => setMode(r.data.mode)); }, []);
    const apply = async () => {
        try {
            await api.put("/reporting/mode", { mode: target });
            toast.success(`Mode Laporan: ${target}`);
            setTimeout(() => window.location.reload(), 600);
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Gagal mengubah Mode Laporan");
        }
        setTarget(null);
    };
    if (!mode) return null;
    return (
        <div className="border border-mist rounded-sm bg-white p-4 space-y-3 max-w-xl" data-testid="mode-switch">
            <div className="text-sm font-medium">Mode Laporan</div>
            <p className="text-xs text-neutral-500">Hanya mengganti tampilan & alur Reporting yang aktif. Tidak memindahkan, menyalin, menghapus, atau menghitung ulang laporan. Laporan lama tetap ada di Riwayat › Laporan lama.</p>
            {["LEGACY", "GROUP"].map((m) => (
                <label key={m} className="flex items-center gap-2 text-sm">
                    <input type="radio" name="reporting-mode" checked={mode === m} onChange={() => m !== mode && setTarget(m)} data-testid={`mode-option-${m}`} />
                    {LABEL[m]}{mode === m && <span className="text-[11px] text-emerald-700" data-testid="mode-current">· aktif</span>}
                </label>
            ))}
            <AlertDialog open={!!target} onOpenChange={(o) => !o && setTarget(null)}>
                <AlertDialogContent data-testid="mode-confirm-dialog">
                    <AlertDialogHeader>
                        <AlertDialogTitle>Ubah Mode Laporan ke {target}?</AlertDialogTitle>
                        <AlertDialogDescription>{MSG[target]}</AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <AlertDialogCancel data-testid="mode-confirm-cancel">Batal</AlertDialogCancel>
                        <AlertDialogAction onClick={apply} data-testid="mode-confirm-ok">Lanjutkan</AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </div>
    );
}
